import {Component, Inject, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '@drl/core/auth/auth.service';
import {User} from '@drl/core/auth/models/user.model';
import {PermissionKey} from '@drl/core/auth/permission-key.enum';
import {ComponentBase} from '@drl/core/component-base';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {environment} from '@drl/env/environment';
import {ChannelKeys} from '@drl/notification/channels-helper';
import {ChatNotifFacadeService} from '@drl/notification/chat-notif-facade.service';
import {ChatNotification} from '@drl/notification/models';
import {SideEffectLogs} from '../../models/side-effect-logs.model';
import {
  AlertNotification,
  Notification,
} from '@drl/notification/models/notification.model';
import {NotificationsService} from '@drl/notification/notifications.service';
import {
  ConfigurationsFacadeService,
  UserFacadeService,
} from '@drl/shared/facades';
import {AlertFacadeService} from '../../../main/patients/alert-facade.service';
import {
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbDialogService,
  NbPopoverDirective,
} from '@nebular/theme';
// import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';
import {TranslateService} from '@ngx-translate/core';
import {isEqual, keys} from 'lodash-es';
import * as moment from 'moment';
import {NgxPermissionsObject, NgxPermissionsService} from 'ngx-permissions';
import {ToastrService} from 'ngx-toastr';
import {forkJoin, of} from 'rxjs';
import {concatMap, distinctUntilChanged, tap} from 'rxjs/operators';
import {BulkUploadComponent} from './bulk-upload/bulk-upload.component';
import {AppoinmentService} from './../../../../app/main/care-central/appoinment.service';
import {CONSTAPPTTYPE} from './../../../../app/main/care-central/dialog-edit-appointment/flags.const';

import {ConfigKeys} from '@drl/core/enums/config-keys.enum';
import {DOCUMENT} from '@angular/common';
import {TenantDetails} from '@drl/shared/models';

const patientsPath = 'main/patients';

@Component({
  selector: 'drl-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent extends ComponentBase {
  logo = `/assets/header-logo-${environment.brand.toLocaleLowerCase()}.svg`;
  brand = environment.brand;
  isEnEnabled = true;
  tenProfile: TenantDetails;

  // sonarignore:start
  constructor(
    private readonly sidebarService: NbSidebarService,
    private readonly menuService: NbMenuService,
    private readonly authService: AuthService,
    protected readonly route: Router,
    private readonly alertFacade: AlertFacadeService,
    private readonly permissionsService: NgxPermissionsService,
    private readonly notifService: NotificationsService,
    private readonly notifFacade: ChatNotifFacadeService,
    private readonly userFacade: UserFacadeService,
    private readonly toastrService: ToastrService,
    protected readonly translateSvc: IpsTranslateService,
    private readonly dialogService: NbDialogService,
    public readonly patientService: AppoinmentService, // sonarignore:end
    private readonly configurationFacade: ConfigurationsFacadeService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    super(route);
    this.translate = this.translateSvc.translate;
    this.getOptionsTranslations();
  }

  translate: TranslateService;
  permissionKeys = PermissionKey;

  user: User;
  loading = false;
  userMenu: NbMenuItem[] = [];
  addOptions: NbMenuItem[] = [];

  addAllowed = false;
  upsertAllowed = false;

  chatNotifications: ChatNotification[] = [];
  chatNotificationsUnread = 0;
  alertNotifs: AlertNotification[] = [];
  alertNotifsUnread = 0;
  otherNotifs: Notification[] = [];
  otherNotifsUnread = 0;
  vcActive: boolean;
  // sonarignore:start
  //isVCEnabled=false;
  // sonarignore:end
  @ViewChild('otherPopover', {static: false}) otherPopover: NbPopoverDirective;
  @ViewChild('chatPopover', {static: false}) chatPopover: NbPopoverDirective;
  @ViewChild('alertPopover', {static: false}) alertPopover: NbPopoverDirective;

  getOptionsTranslations() {
    this.userMenu = [
      {
        title: this.translateSvc.translate.instant('myProfileTitle'),
        link: 'main/profile',
      },
      {
        title: this.translateSvc.translate.instant('changePasswordLbl'),
        link: 'change-password',
      },
      {
        title: this.translateSvc.translate.instant('logoutLbl'),
        data: {isLogout: true},
      },
    ];

    this.addOptions = [
      {
        title: this.translateSvc.translate.instant('patientLbl'),
        link: '/main/patients/add-update',
        data: {
          permission: PermissionKey.CreatePatient,
        },
      },
    ];
  }

  ngOnInit() {
    // const isWhiteLabelled = this.store.getWhiteLabelled();
    // if (isWhiteLabelled && this.store.getMonochromaticTenantLogo()) {
    //   this.logo = this.store.getMonochromaticTenantLogo();
    // }
    // else {
    //   this.logo = `/assets/header-logo.svg`;
    // }
    super.ngOnInit();
    // this.getMonochromeLogo();
    this.translate.onLangChange.subscribe(() => {
      this.getOptionsTranslations();
    });
    this._subscriptions.push(
      this.menuService.onItemClick().subscribe(event => {
        if (event.item.data && event.item.data.isLogout) {
          this.authService.logout();
        }
      }),
    );

    this._subscriptions.push(
      this.authService
        .currentUser()
        .pipe(
          concatMap(user =>
            forkJoin([this.userFacade.getUserById(user.id), of(user)]),
          ),
        )
        .subscribe(resp => {
          this.user = resp[0];
          this.user.role = resp[1].role;

          this.getOptionsTranslations();

          this._subscriptions.push(
            this.checkPermissions().subscribe(async () => {
              await this._setHiddenMenus(this.addOptions);
              if (
                await this.permissionsService.hasPermission(
                  PermissionKey.ManagePatientDetails,
                )
              ) {
                this.refresh();
                this.subscribeToChannels();
              }
            }),
          );
        }),
    );
    // sonarignore:start
    //if(this.isVCEnabled){
    // sonarignore:end
    this.checkVCActive();
    this.getProfile();
    // }
  }

  // getMonochromeLogo() {
  //   const isWhiteLabelled = this.store.getIsWhiteLabelled();
  //   const command: GetIpsAssetsCommand<TenantDetails> = new GetIpsAssetsCommand(
  //     this.apiService,
  //     this.anyAdapter);

  //   command.parameters = {
  //     query: new HttpParams().set('tenantId', '' + this.store.getTenantId()),
  //   };
  //   if (isWhiteLabelled && this.store.getTenantId()) {
  //     command.execute().subscribe((assets: any) =>
  //       this.logo = assets.configValue.monochromeLogo ? assets.configValue.monochromeLogo : `/assets/header-logo-alivius.png`
  //     )
  //   }
  //   else {
  //     this.logo = `/assets/header-logo-alivius.png`;
  //   }
  // }

  checkPermissions() {
    return this.permissionsService.permissions$.pipe(
      distinctUntilChanged(
        (
          currentValue: NgxPermissionsObject,
          previousValue: NgxPermissionsObject,
        ) => isEqual(keys(currentValue), keys(previousValue)),
      ),
    );
  }

  subscribeToChannels() {
    // this.caregroupFacade.getCareGroups().subscribe((careGroups: any[]) => {
    //   let ids = careGroups.map(x => x.id);
    //   this._subscriptions.push(this.notifService.getPubnub(ids).subscribe());
    // });
    this._subscriptions.push(this.notifService.getPubnub().subscribe());
    this._subscriptions.push(
      this.notifService.notificationMsg$.subscribe(message => {
        const msg = message.message.msgData || {};
        if (
          msg.channelKey === ChannelKeys.PatientChannel ||
          msg.channelKey === ChannelKeys.UserP2PChannel
        ) {
          if (
            // sonarignore:start
            (message.message.category === 'chat-message-forward' &&
              msg.notifRecipients &&
              msg.notifRecipients.indexOf(this.user.id) >= 0) ||
            (msg.createdBy !== this.user.id &&
              (msg.toUserId === this.user.id ||
                (msg.notifRecipients &&
                  msg.notifRecipients.indexOf(this.user.id) >= 0)))
            // sonarignore:end
          ) {
            this.toastrService.info(
              message.message.description,
              message.message.title,
              {
                timeOut: environment.messageTimeout,
                enableHtml: true,
              },
            );
          }
          this.getChatNotifs().subscribe();
        }
      }),
    );
    this._subscriptions.push(
      this.notifService.alertNotificationMsg$.subscribe(message => {
        this.toastrService.warning(message.message.description, null, {
          timeOut: environment.messageTimeout,
          enableHtml: true,
        });
        this.getAllNotifs().subscribe();
      }),
    );
  }

  refresh() {
    this.getChatNotifs().subscribe();
    this.getAllNotifs().subscribe();
  }

  getChatNotifs() {
    const twoHours = 2;
    const fromDate = moment().subtract(twoHours, 'h');
    this.chatNotifications = [];
    this.chatNotificationsUnread = 0;
    return forkJoin([
      this.notifFacade.getNotifications(fromDate.toDate()),
      this.notifFacade.getNotifsUnreadCount(fromDate.toDate()),
    ]).pipe(
      tap(res => {
        this.chatNotifications = res[0];
        this.chatNotificationsUnread = res[1].count;
      }),
    );
  }

  getAllNotifs() {
    const chunkSize = Number(environment.allNotificationChunkSize);
    const offset = 1;
    return this.notifService
      .getAllNotifications()
      .pipe(
        concatMap(resp => {
          const respIds = resp.map(notif => notif.id);
          const totalChunks = Math.ceil(respIds.length / chunkSize);
          const notificationUsersArray = [];
          for (let i = 0; i < totalChunks; i++) {
            notificationUsersArray.push(
              this.notifService.getNotificationUsers(
                respIds.slice(i * chunkSize, (i + offset) * chunkSize),
              ),
            );
          }
          return forkJoin([...notificationUsersArray, of(resp)]);
        }),
        concatMap(res =>
          of([[].concat(...res.slice(0, res.length - offset)), res.pop()]),
        ),
      )
      .pipe(
        // sonarignore:start
        tap((res: Array<[]>) => {
          // sonarignore:end
          if (res && res[1]) {
            this.alertNotifs = res[1].filter((notif: {subject}) =>
              ['AlertCreation', 'AlertUpdated'].includes(notif.subject),
            );
          }
          this.alertNotifsUnread = 0;
          this.alertNotifs.forEach(alert => {
            const notifUserEntry: {isRead} = res[0].find(
              (n: {notificationId}) => n.notificationId === alert.id,
            );
            if (notifUserEntry) {
              alert.isRead = notifUserEntry.isRead;
            } else {
              alert.isRead = false;
            }

            if (!alert.isRead) {
              this.getUnreadAlertCount(alert);
            }
          });

          this.otherNotifs = res[1].filter(
            (notif: {subject}) =>
              !['AlertCreation', 'AlertUpdated'].includes(notif.subject),
          );
          if (!this.vcActive) {
            this.otherNotifs = this.otherNotifs.filter(
              other => other.options.apptType !== CONSTAPPTTYPE,
            );
          }
          this.otherNotifsUnread = 0;
          this.otherNotifs.forEach(other => {
            const notifUserEntry: {isRead} = res[0].find(
              (n: {notificationId}) => n.notificationId === other.id,
            );
            if (notifUserEntry) {
              other.isRead = notifUserEntry.isRead;
            } else {
              other.isRead = false;
            }

            if (!other.isRead) {
              this.otherNotifsUnread++;
            }
          });
        }),
      );
  }

  getUnreadAlertCount(alert: AlertNotification) {
    this.alertFacade.fetchAlertById(alert.alertId).subscribe(resp => {
      const alertData = resp;
      this.alertFacade
        .getSideEffectLogs(
          alertData.patientId,
          alertData.createdOn,
          alertData.createdOn,
        )
        .subscribe(res => {
          const sideEffects = res;
          const selectedArr = sideEffects.filter(
            eachEffect => eachEffect.sideEffect === alertData.name,
          );
          const sideEffectToShow = selectedArr.length
            ? selectedArr[0]
            : ({} as SideEffectLogs);
          if (!sideEffectToShow.logDate) {
            this.alertNotifsUnread++;
          } else {
            const logdate = new Date(sideEffectToShow.logDate);
            const createddate = new Date(alertData.createdOn);
            if (
              logdate.getDate() === createddate.getDate() &&
              logdate.getMonth() === createddate.getMonth() &&
              logdate.getFullYear() === createddate.getFullYear()
            ) {
              this.alertNotifsUnread++;
            }
          }
        });
    });
  }
  openAlertNotif(alertNotif: AlertNotification) {
    if (this.alertPopover?.isShown) {
      this.alertPopover.hide(); // Hide the popover
    }
    if (this.alertNotifsUnread > 0) {
      const alertNotifs = this.alertNotifs
        .filter(an => !an.isRead)
        .map(alertN => {
          return {
            notificationId: alertN.id,
            userId: this.user.id,
            isRead: true,
          };
        });
      this.notifService.markNotifsAsRead(alertNotifs).subscribe(() => {
        this.alertNotifsUnread = 0;
        this.router.navigate(
          [patientsPath, alertNotif.patient.externalId, 'alerts'],
          {
            state: {data: {alertId: alertNotif.alertId, pageId: 'alert'}},
          },
        );
      });
    } else {
      this.router.navigate(
        [patientsPath, alertNotif.patient.externalId, 'alerts'],
        {
          state: {data: {alertId: alertNotif.alertId, pageId: 'alert'}},
        },
      );
    }
  }

  openOtherNotif(notif: Notification) {
    if (this.otherPopover?.isShown) {
      this.otherPopover.hide();
    }
    // sonarignore:start
    const {options = {}} = notif as {options};
    const patientExternalId =
      options && options.patientExternalId ? options.patientExternalId : '';
    // sonarignore:end
    let redirectUser = false;
    if (notif.subject === 'DailyAdherenceReminderIps' && patientExternalId) {
      redirectUser = true;
    }

    if (this.otherNotifsUnread > 0) {
      const otherNotifs = this.otherNotifs
        .filter(an => !an.isRead)
        .map(alertNotif => {
          return {
            notificationId: alertNotif.id,
            userId: this.user.id,
            isRead: true,
          };
        });
      this.notifService.markNotifsAsRead(otherNotifs).subscribe(() => {
        this.otherNotifsUnread = 0;
      });
      redirectUser &&
        this.route
          .navigate([patientsPath, patientExternalId, 'adherence'])
          .then(() => {
            window.location.reload();
          });
    } else {
      redirectUser &&
        this.route
          .navigate([patientsPath, patientExternalId, 'adherence'])
          .then(() => {
            window.location.reload();
          });
    }
  }

  openChatNotif(chatNotif: ChatNotification) {
    if (this.chatPopover?.isShown) {
      this.chatPopover.hide();
    }
    forkJoin([
      this.userFacade.getUserById(chatNotif.message.patientUserId),
      this.notifFacade.markNotifAsRead([chatNotif.id]),
    ]).subscribe(resp => {
      this.router.navigate([patientsPath, resp[0].externalId, 'chat'], {
        state: {data: {message: chatNotif.message, pageId: 'chat'}},
      });
    });
  }

  private async _setHiddenMenus(menuItems: NbMenuItem[]) {
    await Promise.all(
      menuItems.map(async menuItem => {
        await this._setHidden(menuItem);
        if (menuItem.children && menuItem.children.length > 0) {
          await this._setHiddenMenus(menuItem.children);
        }
      }),
    );
    const shownMenus = menuItems.filter(mItem => !mItem.hidden);
    this.addAllowed = shownMenus.length > 0;
  }

  private async _setHidden(mItem: NbMenuItem) {
    mItem.hidden =
      mItem.data &&
      mItem.data.permission &&
      mItem.data.permission !== '*' &&
      !(await this.permissionsService.hasPermission(mItem.data.permission));
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  goToHome() {
    this.router.navigate([environment.homePath]);
  }

  openSettings() {
    this.router.navigate(['main/settings']);
  }

  openUploadCsvDialog() {
    this._subscriptions.push(
      this.dialogService.open(BulkUploadComponent).onClose.subscribe(() => {}),
    );
  }
  checkVCActive() {
    const tenantName = {
      config_key: ConfigKeys.VcModuleConfig,
    };
    this.patientService.buttonDetails(tenantName).subscribe(data => {
      this.vcActive = data.configValue[ConfigKeys.IsVcActive];
    });
  }

  changeLanguage(event) {
    this.tenProfile['locale'] = this.isEnEnabled ? 'en' : 'pt-br';
    this._subscriptions.push(
      this.configurationFacade
        .updateTenantConfig(ConfigKeys.Profile, this.tenProfile)
        .subscribe(res => {
          this.document.documentElement.lang = this.tenProfile.locale;
        }),
    );

    this._subscriptions.push(
      this.configurationFacade
        .updateDbSeededValues(this.tenProfile.locale)
        .subscribe(res => {
          this.reloadPage();
        }),
    );
  }
  getProfile() {
    this._subscriptions.push(
      this.configurationFacade.getTenantProfile().subscribe(res => {
        this.translate.setDefaultLang(res.locale);
        this.document.documentElement.lang = res.locale;
        this.tenProfile = res;
        this.isEnEnabled = res.locale === 'en';
      }),
    );
  }

  reloadPage() {
    window.location.reload();
  }
}
